import React from 'react';
import t from 'prop-types';

var Letras = function Letras(_ref) {
  var orden = _ref.orden,
      onDatos = _ref.onDatos;
  return React.createElement('div', {
    className: 'opcionesAlineadas'
  }, orden.map(function (_ref2) {
    var letra = _ref2.letra,
        datos = _ref2.datos;

    if (datos === '') {
      return React.createElement('div', {
        className: 'opcionAlfabetica desactivado',
        key: 'letra-' + letra
      }, letra);
    }

    return React.createElement('div', {
      className: 'opcionAlfabetica',
      key: 'letra-' + letra,
      onClick: function onClick() {
        return onDatos(datos.split(","));
      }
    }, letra);
  }));
};

Letras.propTypes = process.env.NODE_ENV !== "production" ? {
  orden: t.array,
  onDatos: t.func
} : {};
export default Letras;